import CampusLocation from './CampusLocation';

export default CampusLocation;